/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 15:47:10
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import { EAFUseListParams, getEAFUseDetail, getEAFUseExport, getEAFUseList, getEAFUseSubmit, getRemove, SubmitParams, DetailParams } from '../../../services/EAFUse'
// 列表
export const getEAFUseListAsync = createAsyncThunk<
  void,
  EAFUseListParams,
  RootThunkApi<void>
>('EAFUse/getEAFUseListAsync', async (params, api) => {
  return sendAsync(getEAFUseList(params), api)
})

// 详情
export const getEAFUseDetailAsync = createAsyncThunk<
  void,
  DetailParams,
  RootThunkApi<void>
>('EAFUse/getEAFUseDetailAsync', async (params, api) => {
  return sendAsync(getEAFUseDetail(params), api)
})

// 保存编辑
export const getEAFUseSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('EAFUse/getEAFUseSubmitAsync', async (params, api) => {
  return sendAsync(getEAFUseSubmit(params), api)
})

//导出
export const getEAFUseExportAsync = createAsyncThunk<
  void,
  EAFUseListParams,
  RootThunkApi
>('EAFUse/getEAFUseExportAsync ', async (params, api) => {
  return sendAsync(getEAFUseExport(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'EAFUse/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
